















































































import Vue from "vue";
import FilmartKnowhowButton from "@/components/atoms/FilmartKnowhowButton.vue";
import NovelCard from "@/components/atoms/NovelCover.vue";
import ButtonRound from "@/components/atoms/ButtonRound.vue";
import SelectBox from "@/components/molecules/SelectBox.vue";
import {
  genre as genreList,
  category as categoryList,
  workStatus as workStatusList,
  sort as sortList,
} from "@/lib/novelSettings";
import { Novel, NovelSetting } from "@/lib/models";
import clone from "lodash/cloneDeep";
import { compareAsc, compareDesc } from "date-fns";
import isMobile from "ismobilejs";

export default Vue.extend<Data, Methods, Computed, {}>({
  components: { FilmartKnowhowButton, NovelCard, ButtonRound, SelectBox },
  data() {
    return {
      genreList,
      categoryList,
      workStatusList,
      sortList,
    };
  },
  computed: {
    novels() {
      let novels = clone(this.$store.getters["novelModule/novels"] as Novel[]);

      const { genre, category, workStatus, sort, workStatusList, isPC } = this;

      /** フィルタリング */
      if (genre) {
        novels = novels.filter((novel) => novel.genre === genre.id);
      }
      if (category) {
        novels = novels.filter((novel) => novel.category && novel.category.includes(category.id));
      }
      novels = novels.filter((novel) => {
        if (workStatus.id === workStatusList[0].id) {
          return novel.workStatus === null || novel.workStatus === workStatus.id;
        }
        return novel.workStatus === workStatus.id;
      });

      /** ソーティング */
      if (sort) {
        switch (sort.id) {
          case "createdAtAsc":
            novels.sort((x, y) => compareAsc(x.createdAt!, y.createdAt!));
            break;
          case "createdAtDesc":
            novels.sort((x, y) => compareDesc(x.createdAt!, y.createdAt!));
            break;
          case "updatedAtAsc":
            novels.sort((x, y) => compareAsc(x.updatedAtLatestDataInNovel!, y.updatedAtLatestDataInNovel!));
            break;
          case "updatedAtDesc":
            novels.sort((x, y) => compareDesc(x.updatedAtLatestDataInNovel!, y.updatedAtLatestDataInNovel!));
            break;
          case "titleAsc":
            novels.sort((x, y) => x.title.localeCompare(y.title));
            break;
          case "titleDesc":
            novels.sort((x, y) => y.title.localeCompare(x.title));
            break;
          default:
            break;
        }
      }

      /** ピン留め */
      if (isPC) {
        const pinnedNovels = novels.filter((novel) => novel.pinned);
        const unpinnedNovels = novels.filter((novel) => !novel.pinned);
        novels = [...pinnedNovels, ...unpinnedNovels];
      }

      return novels;
    },
    genre() {
      return this.$store.getters["novelModule/genre"];
    },
    category() {
      return this.$store.getters["novelModule/category"];
    },
    workStatus() {
      return this.$store.getters["novelModule/workStatus"];
    },
    sort() {
      return this.$store.getters["novelModule/sort"];
    },
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    selectGenre(item) {
      this.$store.dispatch("novelModule/selectGenre", item);
    },
    unselectGenre() {
      this.$store.dispatch("novelModule/selectGenre", null);
    },
    selectCategory(item) {
      this.$store.dispatch("novelModule/selectCategory", item);
    },
    unselectCategory() {
      this.$store.dispatch("novelModule/selectCategory", null);
    },
    selectWorkStatus(item) {
      this.$store.dispatch("novelModule/selectWorkStatus", item);
    },
    selectSort(item) {
      this.$store.dispatch("novelModule/selectSort", item);
    },
    unselectSort() {
      this.$store.dispatch("novelModule/selectSort", null);
    },
  },
});

interface Data {
  genreList: NovelSetting[];
  categoryList: NovelSetting[];
  workStatusList: NovelSetting[];
  sortList: NovelSetting[];
}

interface Computed {
  novels: Novel[];
  genre: NovelSetting | null;
  category: NovelSetting | null;
  workStatus: NovelSetting;
  sort: NovelSetting | null;
  isPC: boolean;
}

interface Methods {
  selectGenre(item: NovelSetting): void;
  unselectGenre(): void;
  selectCategory(item: NovelSetting): void;
  unselectCategory(): void;
  selectWorkStatus(item: NovelSetting): void;
  selectSort(item: NovelSetting): void;
  unselectSort(): void;
}
